import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { isDefined } from '@sama/js-core';
import { map } from 'rxjs/operators';
import { projectTaskPath } from '../../../cross-team-shared/hub-paths';
import { BrowserControlService } from '../../../cross-team-shared/misc-services/browser-control.service';
import { EventTrackingService } from '../../../shared/event-tracking/event-tracking.service';
import { Task } from '../../../team-apis/otterdam/task';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-production-workspace-header',
  templateUrl: './production-workspace-header.component.html',
  styleUrl: './production-workspace-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductionWorkspaceHeaderComponent {
  @Input() previousTask?: Task;

  private readonly store = inject(TaskWorkspaceStore);
  private readonly eventTrackingService = inject(EventTrackingService);
  private readonly browserControl = inject(BrowserControlService);

  submitters$ = this.store('task')('_extras')('submitters').$;
  project = this.store.state().project;
  task = this.store.state().task;
  isTrainingTask$ = this.store('task')('_extras')('training').$.pipe(
    map(isDefined),
  );

  viewPreviousTask() {
    if (!this.previousTask) {
      throw new Error('there is no previous task');
    }
    this.eventTrackingService.track({
      id: 'view_previous_task',
      bucket: 'navigation',
      sub_bucket: 'page',
    });
    const location = projectTaskPath(this.project.id, this.previousTask);
    this.browserControl.openInNewWindow(location);
  }
}
